import { ILegend, MarkerItem } from './../typings/home.d';
import React from 'react';
import { IPreviewAnalytic } from '../typings/analytics';
import { MenuListItem } from '../typings/menu';
import { ShoppingItem } from '../typings/shopping';
import {
  IDatasetBrief,
  IEnrichedMetadata,
  IMetadataItem,
} from './../typings/metadata.d';
import {
  IPolygonLayer,
  IUploadedLayer,
} from '../components/Map/Layer/DatasetZoneLayer';
import { ICountry, ICurrentUser, IInfoResult } from '../typings/api';
import { ILabelLayer, MapBoundsZoom, ViewportProps } from '../typings/map';
import { INotification } from '../views/Home/Component/Notifications/INotification';
import { IFWEPoint, IInsituPoint } from '../api/FileEndPoint';
import { UserGroupPermissions } from '../typings/userGroupPermissions';

export class StoreData {

  loadingDataFromBSApi: boolean = false
  setLoadingDataFromBSApi: Function = () => { };

  isChangeDatasetWarningVisible: { [key: string]: boolean } = {
    SW: false,
    HD: false,
    Wind: false
  }
  setIsChangeDatasetWarningVisible: Function = () => { }

  activePopupPoint: string = ''
  setActivePopupPoint: Function = () => { };

  closeValidation: boolean = false
  setCloseValidation: Function = () => { }

  fwePoints: IFWEPoint[] = [];
  setFWEPoints: Function = () => { };

  showFWEPoints: boolean = false;
  setShowFWEPoints: Function = () => { };

  fweModelDomains: IPolygonLayer[] = [];
  setFWEModelDomains: Function = undefined as any;

  inSituPoints: IInsituPoint[] = [];
  setInSituPoints: Function = () => { };

  showInSituPoints: boolean = false;
  setShowInSituPoints: Function = () => { };

  notifications: INotification[] = [];
  setNotifications: Function = () => { };

  showNotifications: boolean = false;
  setShowNotifications: Function = () => { };

  countryList: ICountry[] = [];
  setCountryList: Function = () => { };

  segmentsList: IInfoResult[] = [];
  setSegmentsList: Function = () => { };

  companySizeList: IInfoResult[] = [];
  setCompanySizeList: Function = () => { };

  metadatas: IMetadataItem[] = [];
  setMetadatas: Function = () => { };

  previewAnalytics: IPreviewAnalytic[] = [];
  setPreviewAnalytics: Function = () => { };

  user: ICurrentUser = {} as any;
  setUser: Function = () => { };

  userProfileUpdated: boolean = false;
  setUserProfileUpdated: Function = () => { };

  datasetBriefs: IDatasetBrief[] = [];
  setDatasetBrief: Function = undefined as any;

  fweDatasetBriefs: IDatasetBrief[] = [];
  setFWEDatasetBrief: Function = undefined as any;

  enrichedMetadata: IEnrichedMetadata[] = [];
  setEnrichedMetadata: Function = undefined as any;

  showPricingModal: boolean = false;
  setShowPricingModal: Function = undefined as any;

  showContactModal: boolean = false;
  setShowContactModal: Function = undefined as any;

  showFeaturesModal: boolean = false;
  setShowFeaturesModal: Function = undefined as any;

  showGetStartedModal: boolean = false;
  setShowGetStartedModal: Function = undefined as any;

  showDownloadApiModal: boolean = false;
  setShowDownloadApiModal: Function = undefined as any;

  selectDataset: IDatasetBrief | null = null;
  setSelectDataset: Function = undefined as any;

  selectedSearchId: string = '';
  setSelectedSearchId: Function = undefined as any;

  showCart: boolean = false;
  setShowCart: Function = undefined as any;

  showUserProfile: boolean = false;
  setShowUserProfile: Function = undefined as any;

  menuCollapse: boolean = false;
  setMenuCollapse: Function = undefined as any;

  showLayerView: boolean = false;
  setShowLayerView: Function = undefined as any;

  shoppingItems: { [key: string]: { [key: string]: ShoppingItem } } = {};
  setShoppingItems: Function = undefined as any;

  menuList: MenuListItem[] = [];
  setMenuList: Function = undefined as any;

  showSearch: boolean = false;
  setShowSearch: Function = undefined as any;

  showMaintenanceBanner: string = 'false';
  setShowMaintenanceBanner: Function = undefined as any;

  showAdvertisingBanner: string = 'false';
  setShowAdvertisingBanner: Function = undefined as any;

  advertisingBannerButtonText: string = '';
  setAdvertisingBannerButtonText: Function = undefined as any;

  searchId: string = '';
  setSearchId: Function = undefined as any;

  // * all point collection
  markerCollections: MarkerItem[] = [];
  setMarkerCollections: Function = undefined as any;

  // * point selected (Note: only used in some components, others rely on active point in markerCollections)
  point: MarkerItem = {} as any;
  setPoint: Function = undefined as any;

  showDatasetZones: boolean = true;
  setShowDatasetZones: Function = undefined as any;

  showLabelLayer: boolean = true;
  setShowLabelLayer: Function = undefined as any;

  showGraticuleLayer: boolean = false;
  setShowGraticuleLayer: Function = undefined as any;

  datasetZones: IPolygonLayer[] = [];
  setDatasetZones: Function = undefined as any;

  showUploadedShapefile: boolean = false;
  setShowUploadedShapefile: Function = undefined as any;

  showSubscriptionExpiredModal: { message: string, header: string, status: boolean } = {
    message: '', header: '', status: false
  };
  setShowSubscriptionExpiredModal: Function = undefined as any;

  uploadedShapefile: IPolygonLayer[] = [];
  setUploadedShapefile: Function = undefined as any;

  uploadedFeatures: IUploadedLayer[] = [];
  setUploadedFeatures: Function = undefined as any;

  uploadingShapefile: boolean = true;
  setUploadingShapefile: Function = undefined as any;

  visibleUploads: Array<string> = [];
  setVisibleUploads: Function = undefined as any;

  mapBoundsZoom: MapBoundsZoom = { bounds: [0, 0, 0, 0], zoom: 1 };
  setMapBoundsZoom: Function = undefined as any;

  legend: ILegend = {} as any;
  setLegend: Function = undefined as any;

  showLogin: boolean = false;
  setShowLogin: Function = undefined as any;

  showAssociateToCompany: { status: boolean, fun: () => void } = {
    status: false, fun: () => null
  };
  setShowAssociateToCompany: Function = undefined as any;

  showSpectraModal: boolean = false;
  setShowSpectraModal: Function = undefined as any;

  addingPointToMap: boolean = false;
  setAddingPointToMap: Function = undefined as any;

  showResultCollapse: boolean = false;
  setShowResultCollapse: Function = undefined as any;

  graticule: {
    lines: GeoJSON.Feature<GeoJSON.LineString>[];
    points: ILabelLayer[];
  } = {} as any;
  setGraticule: Function = undefined as any;

  isLoading?: boolean = undefined;
  setIsLoading: Function = undefined as any;

  overridePointData: boolean = true;
  setOverridePointData: Function = undefined as any;

  activeCategoryKey: { [key: string] : string | string[]} = {}
  setActiveCategoryKey: Function = () => {}

  depth: {[key: string]: { [key: string]: string | number }} = {}
  setDepth: Function = () => { }

  cellSize: {[key: string]: { [key: string]: string | number }} = {}
  setCellSize: Function = () => { }

  datasetOffline: {[key: string]: { [key: string]: boolean }} = {}
  setDatasetOffline: Function = () => { }

  datasetReport: {[key: string]: { [key: string]: boolean }} = {}
  setDatasetReport: Function = () => { }

  userGroupPermissions: { [key: string]: { [key: string]: UserGroupPermissions }} = {}
  setUserGroupPermissions: Function = () => { }

  isAnalyticsVisible: { [key: string ]: boolean } = {}
  setIsAnalyticsVisible: Function = () => {}

  dropdownSearchbarOpen: boolean = false
  setDropdownSearchbarOpen: (state: boolean) => void = () => { }

  showGlobalShapeFile: boolean = false
  setShowGlobalShapeFile: (state: boolean) => void = () => {}

  showGlobalTextShapeFile: boolean = false
  setShowGlobalTextShapeFile: (state: boolean) => void = () => {}

  showMesh: boolean = false
  setShowMesh: (state: boolean) => void = () => {}

  showSurfaceMap: boolean = false
  setShowSurfaceMap: (state: boolean) => void = () => {}

  timeStepInterval: string = '10'
  setTimeStepInterval: (item: string) => void = () => {}

  addPointName: string = ''
  setAddPointName: (item: string) => void = () => []
}

export const StoreContext = React.createContext(new StoreData());
